import { render } from "./CarouselPosts.vue?vue&type=template&id=7c297b0b&scoped=true"
import script from "./CarouselPosts.vue?vue&type=script&lang=js"
export * from "./CarouselPosts.vue?vue&type=script&lang=js"

import "./CarouselPosts.vue?vue&type=style&index=0&id=7c297b0b&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c297b0b"]])

export default __exports__
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCarousel,QCarouselSlide,QImg,QBtn});
